import React from 'react';
import './DurationSelector.css';

function DurationSelector({ selectedDuration, onDurationChange }) {
  // 节拍选项：按照简谱标准，从短到长排序
  // value = 以四分音符为1的倍数（即占几个四分音符）
  // 1/8拍 = 0.5个四分音符，1/4拍 = 1个四分音符，1/2拍 = 2个四分音符
  const durations = [
    { value: 0.125, label: '1/32拍', underlines: 3, name: '三十二分音符', beats: '1/8拍' },
    { value: 0.25, label: '1/16拍', underlines: 2, name: '十六分音符', beats: '1/4拍' },
    { value: 0.5, label: '1/8拍', underlines: 1, name: '八分音符', beats: '半拍' },
    { value: 1, label: '1/4拍', underlines: 0, rightLines: 0, name: '四分音符', beats: '1拍' },
    { value: 2, label: '1/2拍', rightLines: 1, name: '二分音符', beats: '2拍' },
    { value: 3, label: '3/4拍', rightLines: 2, name: '附点二分音符', beats: '3拍' },
    { value: 4, label: '1全拍', rightLines: 3, name: '全音符', beats: '4拍' },
    { value: 0, label: '休止符', isRest: true, name: '休止符', beats: '停顿' },
  ];

  return (
    <div className="duration-selector">
      <h4 className="duration-title">🎵 选择节拍</h4>
      <div className="duration-grid">
        {durations.map((duration) => (
          <button
            key={duration.value}
            className={`duration-btn ${selectedDuration === duration.value ? 'selected' : ''}`}
            onClick={() => onDurationChange(duration.value)}
            title={duration.name}
          >
            <div className="duration-visual">
              {/* 音符数字示例 */}
              <div className="duration-note">
                <div className="note-with-lines">
                  {/* 音符或休止符 */}
                  <span className="note-example">{duration.isRest ? '0' : '5'}</span>
                  
                  {/* 右侧延长线（长音符）- 横向排列 */}
                  {duration.rightLines > 0 && (
                    <div className="right-lines-horizontal">
                      {[...Array(duration.rightLines)].map((_, i) => (
                        <span key={i} className="right-line-dash">—</span>
                      ))}
                    </div>
                  )}
                </div>
                
                {/* 下方横线（短音符） */}
                {duration.underlines > 0 && (
                  <div className="underlines">
                    {[...Array(duration.underlines)].map((_, i) => (
                      <div key={i} className="underline"></div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="duration-label">{duration.label}</div>
            <div className="duration-beats">{duration.beats}</div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default DurationSelector;

